<template>
  <div class="kr-layout-content">
    <!--个人基本资料-->
    <div class="publish graphicManage">
      <div class="publish-top">
        <ul class="per-list">
          <li class="active">图文管理</li>
        </ul>
      </div>
      <!-- 搜索 -->
      <div class="classify">
        <div class="search-cont">
          <input
            type="text"
            placeholder="请输入关键词进行搜索"
            v-model="keyWords"
            v-on:keyup.enter="getList(keyWords)"
          />
          <label @click="getList(keyWords)">搜索</label>
        </div>
      </div>
	  <div class="tab_cas">
		  <span :class="tabCas==0 ? 'active': ''"  @click="tabTabCas(0)">全部</span>
		  <span :class="tabCas==3 ? 'active': ''" @click="tabTabCas(3)">已发布</span>
		  <span :class="tabCas==2 ? 'active': ''" @click="tabTabCas(2)">未通过</span>
		  <span :class="tabCas==1 ? 'active': ''" @click="tabTabCas(1)">审核中</span>
		  <span :class="tabCas==4 ? 'active': ''" @click="tabTabCas(4)">草稿</span>
	  </div>
      <!-- 列表 -->
      <ul class="edit-article">
        <li class="list" v-for="(item,index) in manageList" :key="index">
          <div class="art-img">
            <img :src="item.pic" alt />
          </div>
          <div class="cont">
            <div class="title-top">
              <p class="title oneline">{{item.title}}</p>
              <div v-if="item.status==3" class="sta-btn pass">已发布</div>
              <div v-if="item.status==2" class="sta-btn no-pass">未通过</div>
              <div v-if="item.status==1" class="sta-btn check">审核中</div>
              <div v-if="item.status==4" class="sta-btn draft">草稿</div>
            </div>
            <p class="intro twoline">{{item.keyWorks}}</p>
            <ul class="detail">
              <li>{{item.createTime}}</li>
              <li>点赞:{{item.zanNum}}</li>
              <li>收藏:{{item.shoucangNum}}</li>
              <li>评论:{{item.commentNum}}</li>
            </ul>
          </div>
          <div class="operation">
            <!-- <span class="redact" v-if="item.status!=3" @click="edit(item.id,item.status)">编辑</span> -->
            <span class="redact" @click="edit(item.id,item.status)">编辑</span>
            <span class="sold-out" @click="details(item.id)">浏览</span>
            <span class="del" @click.stop="dele(item.id)">删除</span>
          </div>
        </li>
      </ul>
      <p v-if="listNone" class="none-more">暂无信息</p>

      <!-- 分页 -->
      <div v-if="!listNone" class="paging">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            layout="prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { spawn } from "child_process";
export default {
  // name: "App",
  data() {
    return {
      num: 0,
      keyWords: "",
	  tabCas:0,
      manageList: [],
      totalNum: 0,
      pagetNo:1,
      currentPage3: 1, //当前页数
      listNone: false,
      ruleContent: ""
    };
  },
  mounted() {
    this.getList(this.keyWords);
  },
  methods: {
    handleSizeChange(val) {
      this.pageNo = val;
      this.getList();
      document.documentElement.scrollTop = 0;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
      document.documentElement.scrollTop = 0;
    },
    getList(keyWords,status) {
      //图文管理列表
      this.$http
        .get("/api/media/004--myNewsList", {
          params: {
            type: 1,
            title: keyWords,
            pageNo: this.pageNo,
            token: this.$store.state.userInfo.token,
			status:status==0 ? '' : status
          }
        })
        .then(res => {
          console.log(res, "图文管理列表");
          if (res.data.code == 0) {
            this.manageList = res.data.rows;
            if (res.data.rows.length == 0) {
              this.listNone = true;
            } else {
              this.totalNum = res.data.totalCount;
              this.num = res.data.rows[0].todayCount;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
	tabTabCas(type){ //状态
		this.tabCas = type
		this.getList('',type)
	},
    dele(id) {
      //媒体认证
      this.$http
        .get("/api/media/006-delMyNewsById", {
          params: {
            id: id,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "删除");
          if (res.data.code == 0) {
            this.getList();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    edit(id, status) {
      this.$router.push({
        path: "/publishArticle",
        query: { id: id, n: 1, status: status}
      });
    },
    details(id) {
      //图文详情
      this.$router.push({ path: "/ghDetails", query: { id: id, type: 1 } });
    }
  }
};
</script>
<style>
.el-pager li {
  color: #999 !important;
}
.el-pager li:hover {
  color: #2e8043 !important;
}
.el-pager li.active {
  color: #2e8043 !important;
}
.el-pagination button:hover {
  color: #2e8043 !important;
}
.el-pagination .btn-next:hover {
  color: #2e8043 !important;
}
.el-pagination__editor.el-input .el-input__inner:focus {
  border: 1px solid #2e8043 !important;
}

.el-message-box {
  width: 600px !important;
}
.el-message-box__headerbtn:hover .el-message-box__close {
  color: #2e8043;
}
.el-button--primary {
  background-color: #fff !important;
}

button:not(:disabled),
[type="button"]:not(:disabled) {
  width: 55px;
  height: 30px;
}
.el-button--primary:hover {
  background: none !important;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background-color: red;
}
.tab_cas{
	width: 100%;
	overflow: hidden;
	font-size: 18px;
	color: #000;
	margin-top: 20px;
}
.tab_cas span{
	display: block;
	float: left;
	margin-right: 30px;;
}
.tab_cas span.active{
	color: #2e8043;
}
</style>